<div class="modal-header bg-dark">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="icons-office-52"></i>
  </button>
  <h4 class="modal-title">Rimozione <strong>Utente</strong></h4>
</div>
<div class="modal-body">
  <p>Confermi la rimozione dell'utente "{{ user.username }}"?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default btn-blue btn-embossed" (click)="activeModal.close(user)">Conferma</button>
  <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
